export enum KfmAppShoppingCartColumns {
  PositionNumber = 0,
  Quantity = 1,
  UnitOfMeasure = 2,
  ItemNumber = 3,
  Performance = 4,
  UnitPrice = 5,
  TotalPrice = 6,
  Vat = 7,
}
